import { render, staticRenderFns } from "./sxcitybrainSSO.vue?vue&type=template&id=597e4586&scoped=true&"
import script from "./sxcitybrainSSO.vue?vue&type=script&lang=js&"
export * from "./sxcitybrainSSO.vue?vue&type=script&lang=js&"
import style0 from "./sxcitybrainSSO.vue?vue&type=style&index=0&id=597e4586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e4586",
  null
  
)

export default component.exports